import React from 'react'

const Required = () => {
  return <span style={{ color: 'red' }}>*</span>
}

export default Required